import { Component } from 'preact';
import s from './style.css';
import cn from 'classnames';
import Container from 'components/Container';
import NextArrow from 'components/NextArrow';

const data = [
	{ name: 'Work', percentage: 22 },
	{ name: 'Friends', percentage: 18 },
	{ name: 'Online dating', percentage: 13 },
	{ name: 'Night out', percentage: 10 },
	{ name: 'Social event', percentage: 8 },
	{ name: 'School or uni', percentage: 7 },
	{ name: 'Family', percentage: 6 },
	{ name: 'Shared hobby', percentage: 3 },
	{ name: 'Holiday', percentage: 2 },
	{ name: 'Other', percentage: 11 }
];

class HowWeMeet extends Component {
	constructor(props) {
		super(props);
		this.state = {
			inView: true
		};
	}

	componentWillMount() {
		const threshold = 0.3;

		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(
				entries => {
					entries.forEach((entry, i) => {
						if (entry.intersectionRatio > threshold) {
							this.props.inViewCallback();
							this.setState({ inView: true });
							this.observer.unobserve(this.viz);
						}
						else {
							this.setState({ inView: false });
						}
					});
				},
				{
					rootMargin: '0px',
					threshold
				}
			);
		}
	}

	componentDidMount() {
		this.observer.observe(this.viz);
	}

	componentWillUnmount() {
		this.observer.unobserve(this.viz);
	}

	render() {
		const { max = 22, delay = 0.1 } = this.props;

		return (
			<div className={s.root} id={'how-we-meet'}>
				<Container>
					<div className={s.text}>
						<p>
							We discovered that you’re more likely to meet your partner at work
							than in a bar, online or even through friends.
						</p>
						<p>Here’s how we meet our partners:</p>
					</div>

					<div className={s.extra}>
						<div
							className={cn(s.wrapper, { [s.inView]: this.state.inView })}
							ref={elem => (this.viz = elem)}
						>
							{data.map(({ name, percentage }, i) => (
								<div
									className={s.heart}
									style={{ transitionDelay: `${delay * i}s` }}
								>
									<div className={s.vizWrap}>
										<div
											className={s.viz}
											style={{
												transitionDelay: `${delay * i}s`,
												width: `${Math.sqrt(
													percentage / max * 100 / (Math.PI + 4)
												) * 27}%`
											}}
										>
											<div
												className={s.vizInner}
												style={{
													transitionDelay: `${delay * i}s`
												}}
											/>
										</div>
									</div>

									<div className={s.labelWrap}>
										<div
											className={s.label}
											style={{
												transitionDelay: `${delay * i + 0.5}s`
											}}
										>
											<div className={s.labelInner}>
												<strong>{percentage}%</strong>
												{name}
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<p className={s.next}>
						<NextArrow to="working-with-the-one-you-love" />
					</p>
				</Container>
			</div>
		);
	}
}

HowWeMeet.defaultProps = {
	inViewCallback: () => {}
};

export default HowWeMeet;



// WEBPACK FOOTER //
// ./components/HowWeMeet/index.js